import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=83f8fd3c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=83f8fd3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f8fd3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83f8fd3c')) {
      api.createRecord('83f8fd3c', component.options)
    } else {
      api.reload('83f8fd3c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=83f8fd3c&scoped=true&", function () {
      api.rerender('83f8fd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lxim1T9y6JHr/JS/comp/PopupDialog.vue"
export default component.exports